import React, { PureComponent } from 'react'
import { ReactComponent as Icon } from './assets/elasticsearch.svg'
import SvgIcon from '@material-ui/core/SvgIcon'

export default class Elasticsearch extends PureComponent {
  render() {
    return <SvgIcon component={Icon} viewBox='0 0 64 64' />
  }
}
